/**
 * Rounds the minutes of a given date string to the nearest multiple of 5, either up or down.
 *
 * @param {string} dateString - The date string in ISO format (or any valid date format).
 * @param {'up' | 'down'} roundDirection - Determines whether to round up or down.
 * @returns {string} - The modified date string with minutes rounded up or down to the nearest multiple of 5, in ISO 8601 format.
 *
 * @example
 * // Returns '2024-10-21T12:20:00.000Z' when input is '2024-10-21T12:17:30.000Z' and roundDirection is 'up'
 * roundToNearestFiveMinutes('2024-10-21T12:17:30.000Z', 'up');
 *
 * // Returns '2024-10-21T12:15:00.000Z' when input is '2024-10-21T12:17:30.000Z' and roundDirection is 'down'
 * roundToNearestFiveMinutes('2024-10-21T12:17:30.000Z', 'down');
 */
export function roundToNearestFiveMinutes(dateString: string, roundDirection: 'up' | 'down'): string {
	const date = new Date(dateString);
	const minutes = date.getMinutes();

	let roundedMinutes: number;
	if (roundDirection === 'up') {
		roundedMinutes = Math.ceil(minutes / 5) * 5;
	} else {
		roundedMinutes = Math.floor(minutes / 5) * 5;
	}

	if (roundedMinutes === 60) {
		date.setHours(date.getHours() + 1);
		roundedMinutes = 0;
	}

	date.setMinutes(roundedMinutes, 0, 0);

	return date.toISOString();
}
